/* useInboxUnread — light polling hook for the top-bar badge. */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const POLL_MS = 45_000;

export default function useInboxUnread() {
  const [total, setTotal] = useState(0);
  useEffect(() => {
    let cancelled = false;
    const load = () => api.get("/inbox/unread")
      .then(({ data }) => { if (!cancelled) setTotal(data.total || 0); })
      .catch(() => {});
    load();
    const iv = setInterval(load, POLL_MS);
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => { cancelled = true; clearInterval(iv); window.removeEventListener("focus", onFocus); };
  }, []);
  return total;
}
